import React from 'react'
import { RightSection, StyledTabs, TrafficButton, Text } from './index.styled'
import { Info } from './Info'
import Notes from './Notes'
import { Scans } from './Scans'
import Traffic from './Traffic'
import { usePatientReport } from './usePatientReport'

export default function PatientReportPanel() {
  const { currentPatient, rightTab, setRightTab } = usePatientReport()

  return (
    <RightSection>
      {currentPatient && (
        <>
          <StyledTabs
            activeKey={rightTab}
            onChange={(key) => setRightTab(key as any)}
            items={[
              { key: 'info', label: 'Info', children: <Info /> },
              { key: 'scans', label: 'Scans', children: <Scans /> },
              { key: 'notes', label: 'Notes', children: <Notes /> },
              { key: 'traffic', label: 'Traffic', children: <Traffic /> },
            ]}
            tabBarExtraContent={
              <TrafficButton
                $active={rightTab === 'traffic'}
                onClick={() => setRightTab('traffic')}
                style={{
                  boxShadow: rightTab === 'traffic' ? '0 2px 4px rgba(0, 0, 0, 0.25)' : 'var(--shadow-box)',
                }}
              >
                <Text $bold $color={rightTab === 'traffic' ? 'var(--color-primary)' : 'var(--color-text-primary)'}>
                  Traffic
                </Text>
              </TrafficButton>
            }
          />
        </>
      )}
    </RightSection>
  )
}
